export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholder404@2x.png";